import Axios from 'axios';

import { getBootstrap } from '@client/app/bootstrap';

import { logGroup } from '@client/utils/logger';

const { environment } = getBootstrap();

export const TransportUtils = {
  axiosCreate(options) {
    const axios = Axios.create(options);

    axios.interceptors.request.use(
      (config) => ({
        ...config,
        t0: performance.now()
      }),
      (error) => Promise.reject(error)
    );

    const logEvents = (config) => {
      // Errors that never dispatched (CORS blocks, interceptor throws) have no config.
      if (!config) {
        return;
      }

      if (environment !== 'production') {
        const value = performance.now() - config.t0;

        logGroup('info', 'API', 'Request Latency', {
          duration: value,
          method: config.method.toUpperCase(),
          url: config.url
        });
      }
    };

    axios.interceptors.response.use(
      (response) => {
        logEvents(response.config);
        return response;
      },
      (error) => {
        logEvents(error.config);
        return Promise.reject(error);
      }
    );

    return axios;
  }
};
